import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/client/components/HomePageClient.jsx");
